module.exports = __webpack_public_path__ + "8fcad3abecea004a0a799506fdcae514.svg";